import { useState, FC } from 'react'
import { useTranslation } from 'react-i18next'
import PerButtonCircle from '../../../components/custom_components/ButtonCircle'
import { MeetingInviteModal } from './MeetingInviteModal'
import PerButton from '../../../components/custom_components/Button'
import { EmployeeDisplayTinyInfo } from '../../../types'

interface NewMeetingInviteButtonProps {
  employeeList: EmployeeDisplayTinyInfo[]
  btnType?: 'normal' | 'circle' | 'nextMeetingsTile'
  btnSize?: 'small' | 'large'
  width?: 'fullWidth'
  variant?: 'pastel'
}

export const NewMeetingInviteButton: FC<NewMeetingInviteButtonProps> = ({ employeeList, btnType = 'circle', btnSize, width, variant }) => {
  const [t] = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const cleanAndCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      {employeeList.length !== 0 && (
        <>
          <MeetingInviteModal employeeList={employeeList} onCancel={cleanAndCloseModal} visible={isModalOpen} />

          {btnType === 'normal' && (
            <PerButton
              data-e2e-empty-meetings-table-invite-btn
              onClick={(e) => {
                e.preventDefault() // We should refactor button to not emit native event!
                setIsModalOpen(true)
              }}
              before="invite_fill"
              color="primary"
              text={t('meetingButtonActions.invite')}
              size={btnSize && 'small'}
              width={width}
              variant={variant}
            />
          )}
          {btnType === 'circle' && (
            <PerButtonCircle
              data-e2e-manager-meeting-invite-icon-btn
              onClick={(e) => {
                e.preventDefault() // We should refactor button to not emit native event!
                setIsModalOpen(true)
              }}
              color="primary"
              icon="invite_fill"
              variant="pastel"
              tooltip={t('meetingButtonActions.invite')}
              size={btnSize}
            />
          )}
        </>
      )}
    </>
  )
}
